import React, { useState, useEffect } from "react";
import "./order.css";

const Order = () => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch("https://backend-n2zq.onrender.com/Orderdetails");
      if (!response.ok) {
        throw new Error("Failed to fetch orders");
      }
      const data = await response.json();
      setOrders(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredOrders = orders.filter((order) => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return (
        (order.id?.toString().toLowerCase() || "").includes(query) ||
        (order.first_name?.toLowerCase() || "").includes(query) ||
        (order.last_name?.toLowerCase() || "").includes(query) ||
        (order.email?.toLowerCase() || "").includes(query) ||
        (order.gender?.toLowerCase() || "").includes(query)
      );
    }
    return true;
  });

  return (
    <div className="page-container" style={{ width: "85vw" }}>
      <div className="list-top">
        <div className="class">
          <h3>Orders ({filteredOrders.length})</h3>
        </div>
          <input  className="search"
            type="text"
            placeholder="Type to Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
         </div>

      <div style={{ overflowY: "auto" }}>
        {isLoading ? (
          <p style={{ textAlign: "center", marginTop: "60px" }}>Loading...</p>
        ) : error ? (
          <p style={{ textAlign: "center", marginTop: "60px", color: "red" }}>
            {error}
          </p>
        ) : filteredOrders.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order, index) => (
                <tr key={index}>
                  <td>{order.id}</td>
                  <td>{order.first_name}</td>
                  <td>{order.last_name}</td>
                  <td>{order.email}</td>
                  <td>{order.gender}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center", marginTop: "60px" }}>
            No order details available
          </p>
        )}
      </div>
    </div>
  );
};

export default Order;









